module.exports = __webpack_public_path__ + "img/lige.d766bef7.png";